
(function() {
  var bar      = document.getElementById('vyper-satc');
  var idInput  = document.getElementById('vyper-satc-id');
  var btn      = bar  ? bar.querySelector('.vyper-satc__btn') : null;
  var priceEl  = document.getElementById('vyper-satc-price');
  var varLabel = document.getElementById('vyper-satc-variant-label');
  var imgWrap  = document.getElementById('vyper-satc-img');
  if (!bar) return;

  /* ── Show / hide: watch main ATC form ─────────────────────────────── */
  var mainForm = document.querySelector('form[data-type="add-to-cart-form"]');

  function show() { bar.classList.add('is-visible'); bar.removeAttribute('aria-hidden'); }
  function hide() { bar.classList.remove('is-visible'); bar.setAttribute('aria-hidden', 'true'); }

  if (mainForm && 'IntersectionObserver' in window) {
    new IntersectionObserver(function(entries) {
      entries.forEach(function(e) { e.isIntersecting ? hide() : show(); });
    }, { threshold: 0, rootMargin: '0px 0px -20px 0px' }).observe(mainForm);
  } else {
    window.addEventListener('scroll', function() {
      window.scrollY > 400 ? show() : hide();
    }, { passive: true });
  }

  /* ── Sync variant input from main form (MutationObserver fallback) ─── */
  if (mainForm) {
    var masterInput = mainForm.querySelector('input[name="id"]');
    if (masterInput) {
      new MutationObserver(function() {
        if (masterInput.value) idInput.value = masterInput.value;
      }).observe(masterInput, { attributes: true, attributeFilter: ['value'] });
    }
  }

  /* ── React to variant change events ───────────────────────────────── */
  /* Liquid is NOT processed in /assets/*.js. Read defaults from data-* on
   * the bar itself (set by the section snippet), with sensible fallbacks. */
  var ORIG_BTN_TEXT = (btn && btn.textContent.trim()) || 'In den Warenkorb';
  var SOLD_OUT_TEXT = bar.dataset.soldoutText || 'Ausverkauft';
  var CURRENCY_SYM  = bar.dataset.currencySymbol || 'CHF ';

  function onVariantChange(e) {
    var v = e.detail && e.detail.variant;
    if (!v) return;

    /* id */
    idInput.value = v.id;

    /* button state */
    if (btn) {
      btn.disabled = !v.available;
      btn.textContent = v.available ? ORIG_BTN_TEXT : SOLD_OUT_TEXT;
    }

    /* price */
    if (priceEl) {
      var sym = CURRENCY_SYM;
      var p   = (v.price / 100).toFixed(2);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        var cp = (v.compare_at_price / 100).toFixed(2);
        priceEl.innerHTML = '<s>' + sym + cp + '</s> <span class="price--sale">' + sym + p + '</span>';
      } else {
        priceEl.textContent = sym + p;
      }
    }

    /* variant label */
    if (varLabel) {
      varLabel.textContent = (v.title && v.title !== 'Default Title') ? v.title : '';
    }

    /* image */
    if (imgWrap && v.featured_image) {
      var src = v.featured_image.src;
      /* Shopify CDN sizing */
      src = src.replace(/(\.[^.?]+)(\?.*)?$/, '_96x96$1$2');
      var existing = imgWrap.querySelector('img');
      if (existing) {
        existing.src = src;
        existing.alt = v.featured_image.alt || '';
      } else {
        var img = document.createElement('img');
        img.src    = src;
        img.alt    = v.featured_image.alt || '';
        img.width  = 48;
        img.height = 48;
        imgWrap.appendChild(img);
      }
    }
  }
  /* Listen to both standard and vyper-picker custom event names. */
  document.addEventListener('variant:change',       onVariantChange);
  document.addEventListener('vyper:variant:change', onVariantChange);

  /* ── AJAX add to cart ──────────────────────────────────────────────── */
  document.getElementById('vyper-satc-form').addEventListener('submit', function(e) {
    e.preventDefault();
    if (!btn || btn.disabled) return;

    var origText = btn.textContent;
    btn.disabled    = true;
    btn.textContent = '...';

    /* Fly-to-cart animation (same source priority as PDP main ATC). */
    flyToCart();

    /* Hardcoded path — this file is served as a static asset, Liquid
     * is NOT processed in /assets/*.js so `{{ routes.cart_add_url }}` would
     * have been a literal string and the fetch would have hit a 404. */
    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body:    JSON.stringify({ id: idInput.value, quantity: 1 })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('cart add HTTP ' + r.status);
      return r.json();
    })
    .then(function(data) {
      if (data.status && data.status !== 200) throw new Error(data.description || 'add failed');
      /* Notify cart drawer + sync logic */
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: data } }));
      window.dispatchEvent(new CustomEvent('cart:item-added',   { detail: { product: data } }));
      btn.textContent = 'Hinzugefügt ✓';
      /* Open drawer after a small delay so user sees the fly land */
      setTimeout(function(){
        var toggle = document.getElementById('cart-drawer-toggle');
        if (toggle) toggle.click();
      }, 700);
      setTimeout(function() {
        btn.disabled    = false;
        btn.textContent = origText;
      }, 1800);
    })
    .catch(function(err) {
      console.warn('[vyper-satc] cart add failed', err);
      btn.disabled    = false;
      btn.textContent = origText;
    });
  });

  /* ── Fly-to-cart animation (mirrors main PDP ATC) ─────────────────── */
  function isInViewport(rect){
    if (!rect || rect.width === 0 || rect.height === 0) return false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var vw = window.innerWidth  || document.documentElement.clientWidth;
    return rect.bottom > 0 && rect.top < vh && rect.right > 0 && rect.left < vw;
  }
  /* For the sticky bar we prefer the sticky's own visible thumbnail because
   * the variant-picker / main gallery are usually scrolled way off-screen
   * by the time the bar appears (clone would animate outside the viewport). */
  function pickProductImage(){
    var sel = [
      '#vyper-satc-img img',
      '.vyper-variant-picker input[type="radio"]:checked + .vyper-variant-picker__item .vyper-variant-picker__image',
      '.vyper-variant-picker input[type="radio"]:checked + .vyper-variant-picker__item img',
      '.product-images__slide.is-selected img',
      '.product-image-container .is-selected img',
      '.product-image-container img'
    ];
    var fallback = null;
    for (var i = 0; i < sel.length; i++) {
      var el = document.querySelector(sel[i]);
      if (!el) continue;
      var r = el.getBoundingClientRect();
      if (r.width < 20 || r.height < 20) continue;
      if (isInViewport(r)) return el;
      if (!fallback) fallback = el;
    }
    return fallback;
  }
  function flyToCart(){
    var img = pickProductImage();
    var target = document.getElementById('cart-drawer-toggle');
    if (!img || !target) return;
    var s = img.getBoundingClientRect();
    var t = target.getBoundingClientRect();
    if (s.width === 0 || t.width === 0) return;

    // Clone for animation
    var clone = img.cloneNode(true);
    clone.removeAttribute('loading');
    clone.removeAttribute('class');
    clone.className = 'vyper-fly-clone';
    clone.style.width  = s.width  + 'px';
    clone.style.height = s.height + 'px';
    clone.style.transform = 'translate(' + s.left + 'px,' + s.top + 'px) scale(1) rotate(0deg)';
    clone.style.transformOrigin = '0 0';
    clone.style.opacity = '1';
    document.body.appendChild(clone);

    // Trail particles
    var trails = [];
    for (var i = 0; i < 6; i++) {
      var tr = document.createElement('div');
      tr.className = 'vyper-fly-clone--trail';
      tr.style.transform = 'translate(' + (s.left + s.width/2) + 'px,' + (s.top + s.height/2) + 'px)';
      document.body.appendChild(tr);
      trails.push(tr);
    }

    var endX = t.left + t.width/2 - 16;
    var endY = t.top  + t.height/2 - 16;
    var finalScale = Math.max(0.12, 32 / s.width);
    void clone.offsetWidth;

    requestAnimationFrame(function(){
      clone.style.transform =
        'translate(' + endX + 'px,' + endY + 'px) ' +
        'scale(' + finalScale + ') rotate(-22deg)';
      clone.style.opacity = '0.35';
      clone.style.borderRadius = '50%';

      trails.forEach(function(tr, i){
        var spread = 18 + i * 6;
        var ang = (-90 + (i - 2.5) * 20) * Math.PI / 180;
        var midX = (s.left + endX) / 2 + Math.cos(ang) * spread;
        var midY = (s.top  + endY) / 2 + Math.sin(ang) * spread;
        tr.style.transitionDelay = (i * 40) + 'ms';
        tr.style.transform = 'translate(' + midX + 'px,' + midY + 'px) scale(' + (1 + i*0.2) + ')';
        tr.style.opacity = '0';
      });
    });

    setTimeout(function(){
      clone.remove();
      trails.forEach(function(tr){ tr.remove(); });
      target.classList.add('vyper-cart-receive');
      if (navigator.vibrate) { try { navigator.vibrate([8, 30, 14]); } catch(_){} }
      setTimeout(function(){ target.classList.remove('vyper-cart-receive'); }, 600);
    }, 900);
  }
})();
